import React from "react";
import { useLocation } from "react-router-dom";

// WhatsApp: número de contacto. Cambiar aquí si algún día se actualiza.
const WHATSAPP_NUMBER = "34655958586";

const HIDDEN_ROUTES = [/^\/admin/, /^\/payment\//];

export default function WhatsAppFab() {
  const { pathname } = useLocation();
  if (HIDDEN_ROUTES.some((r) => r.test(pathname))) return null;

  return (
    <a
      href={`https://wa.me/${WHATSAPP_NUMBER}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      data-testid="whatsapp-fab"
      className="fixed bottom-5 right-5 z-40 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-60 animate-ping-slow" aria-hidden="true"></span>
      <span className="relative flex items-center justify-center w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#128C7E] transition-all duration-300 shadow-[0_8px_24px_rgba(37,211,102,0.4)] hover:scale-110">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-7 h-7 fill-white"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39-.156 0-.311-.078-.466-.155-1.088-.544-2.021-1.244-2.876-2.099-.233-.234-1.166-1.4-1.166-1.71 0-.078 0-.156.078-.234.155-.234.31-.311.466-.544.155-.234.155-.389.311-.622.078-.234 0-.467-.078-.622-.155-.311-.7-1.71-.855-2.099-.155-.389-.311-.311-.466-.311s-.311 0-.467 0c-.155 0-.389.155-.544.234-.622.622-.933 1.244-.933 2.177 0 .933.311 1.71.7 2.488.7 1.322 1.71 2.488 2.877 3.42 1.088.855 2.487 1.633 3.887 2.021.7.234 1.322.234 1.944.156.622-.078 1.788-.7 2.021-1.4.234-.7.234-1.322.156-1.478-.155-.078-.311-.155-.544-.311zM24.322 8.988c-2.487-2.488-5.83-3.887-9.328-3.887-7.229 0-13.137 5.908-13.137 13.137 0 2.332.622 4.586 1.788 6.607L2 32l7.62-1.944c1.944 1.088 4.198 1.633 6.374 1.633 7.229 0 13.137-5.908 13.137-13.137 0-3.498-1.4-6.762-3.809-9.564zm-9.328 20.288c-1.944 0-3.887-.544-5.597-1.556l-.389-.234-4.043 1.088 1.088-3.887-.234-.389c-1.088-1.788-1.71-3.809-1.71-5.83 0-6.14 4.976-11.117 11.117-11.117 2.954 0 5.752 1.166 7.85 3.265 2.099 2.099 3.265 4.898 3.265 7.85-.078 6.14-5.054 11.117-11.194 11.117z" />
        </svg>
      </span>
    </a>
  );
}
